const webURL = 'https://test.tenant.reposit.co.uk';
const clientId = 'CvG6gXjhMb4cUYUykoC2jp7hqh7iTvyv';
const paymentPlanPortalURL = 'https://test.tenant-portal.reposit.co.uk';

export const appConfig = {
  links: {
    auth0: {
      logout: `https://reposit-test.eu.auth0.com/v2/logout?client_id=${clientId}`,
      login: `https://reposit-test.eu.auth0.com/authorize?response_type=token&client_id=${clientId}&redirect_uri=${webURL}/authenticate&audience=https://test.api.com`,
    },
    local: {
      login: `${webURL}/login`,
    },
    paymentPlanPortal: paymentPlanPortalURL,
  },
  api: {
    basePath: 'https://test.api.reposit.co.uk',
  },
  analytics: {
    trackers: [
      {
        name: 'test',
        id: 'UA-81451405-6',
      },
    ],
  },
  stripe: {
    apiKey: 'pk_test_51TEqArHh21g2P7V1KGmggx2MukpVSjWRdnG2A7yXX7Vz85yiiQFT10CoHLye4ch6WF1EHdpQUrk5zujZ7GseYt0E00pyCHWh8C',
  },
  intercom: {
    appId: 's7plajks',
    enabled: true,
  },
  hotjar: {
    enabled: false,
    siteId: 0,
    hotjarVersion: 6,
  },
  trustPilot: {
    repositOfferTrustBoxEnabled: true,
  },
  inMaintenanceMode: false,
  sentry: {
    enabled: true,
    dsn: 'https://c1d30fcb52ba7ab577a336622a59ab56@o4510641285693440.ingest.de.sentry.io/4511139574054992',
    environment: 'test',
    tracesSampleRate: 1.0,
  },
};
